// extracted by mini-css-extract-plugin
export default {"pulsate":"pulsing-exclamation-mark-icon_pulsate__f+2Xt","pulse":"pulsing-exclamation-mark-icon_pulse__Umj+b","bordered":"pulsing-exclamation-mark-icon_bordered__jcVrs"};